import React from 'react'
import { formatReviewDate } from '../../../helpers/date'
import TypographyAtom from '../../atoms/typography/typography'
import {
  Avatar,
  Container,
  DateWrapper,
  RatingItem,
  RatingWrapper,
  ReviewFooter,
  ReviewHeader,
} from './ReviewItem.styled'

function ReviewItem({ title, body, rating, date, reviewerInitials = 'DC' }) {
  return (
    <Container>
      <ReviewHeader>
        <Avatar>
          <TypographyAtom type="H2" weight="Bold" copy={reviewerInitials} />
        </Avatar>
        <TypographyAtom type="H2" weight="Bold" copy={title} />
      </ReviewHeader>
      <TypographyAtom type="P" weight="Regular" copy={body} />
      <ReviewFooter>
        <DateWrapper>
          <TypographyAtom
            type="P"
            weight="Regular"
            copy={`Review Date: ${formatReviewDate(date)}`}
          />
        </DateWrapper>
        <RatingWrapper>
          {Array(rating)
            .fill(null)
            .map((_, index) => (
              <RatingItem key={index} />
            ))}
        </RatingWrapper>
      </ReviewFooter>
    </Container>
  )
}

export default ReviewItem
